$(document).ready(function () {
  var swiper_value = new Swiper("#mySwiperseValue", {
    slidesPerView: 2,
    autoHeight: false,
    watchOverflow: true,
    spaceBetween: 10,
    autoplay: true,
    breakpoints: {
      640: {
        slidesPerView: 3,
        spaceBetween: 27,
      },
      748: {
        slidesPerView: 3,
        spaceBetween: 27,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 27,
      },
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
  });
});
